<template>
  <div :style="styles.base" :class="getCss('mainGroupContainer')">
    <div v-if="isHorizontalDisplay" :class="getCss('member')" ref="displayMemberContainer">
      <img
        :src="configurationData.leftBackGroundImage"
        v-if="!!configurationData.leftBackGroundImage &&  showArrowIcon  && members.length > 1 "
        :class="getCss('arrow-left-icon')"
        :style="arrowStyle"
        alt
        @click="touchMovePre"
      />
      <div :class="getCss('group-watch-member-window')">
        <div
          :class="{'group-watch-member-scroller':true}"
          ref="groupWatchMemberScroller"
          style="transform: translate3d(0, 0, 0);"
        >
          <ul
            :class="getCss('list')"
            v-for="(data, index) in members"
            :key="Math.floor(Math.random()*10000)+index"
          >
            <li :class="getCss('item')" v-for="(val, indexData) in data" :key="indexData">
              <template v-if="val.valid">
                <div :class="getCss('avatar_container')"
                     :style="{...avatarBackgroundImageStyle,
                      backgroundImage:`url('${val.avatar || configurationData.avatarBackgroundImage}')`
                     }"
                >
<!--                  <img :class="getCss('avatar')" :src="val.avatar || configurationData.avatarBackgroundImage"/>-->
                </div>
                <div :class="getCss('nick')" :style="nickNameStyle" v-if="configurationData.showName"
                     v-html="val.name">
                </div>
              </template>
              <template v-else>
                <img
                  v-show="!!configurationData.avatarBackgroundImage"
                  :class="getCss('avatar')"
                  :src="configurationData.avatarBackgroundImage"
                />
              </template>
            </li>
          </ul>
        </div>
      </div>
      <img
        :src="configurationData.rightBackGroupImage"
        v-if="!!configurationData.rightBackGroupImage && showArrowIcon  && members.length > 1 "
        :class="getCss('arrow-right-icon')"
        alt
        :style="arrowStyle"
        @click="touchMoveNext"
      />
    </div>

    <div v-if="!isHorizontalDisplay" :class="getCss('member-vertical-list')" :style="memberVerticalListStyle">
      <ul
        :class="getCss('vertical-list-area')"
        v-if="verticalMembers.length > 0"
      >
        <li :class="getCss('vertical-list-item')"   v-for="(val, indexData) in verticalMembers" :key="indexData">
          <template v-if="val.valid">
            <div :class="getCss('avatar_container')"
                 :style="{...avatarBackgroundImageStyle,
                      backgroundImage:`url('${val.avatar || configurationData.avatarBackgroundImage}')`
                     }"
            >
            </div>
            <div :class="getCss('nick')" :style="nickNameStyle" v-if="configurationData.showName"
                 v-html="val.name">
            </div>
          </template>
          <template v-else>
            <img
              v-show="!!configurationData.avatarBackgroundImage"
              :class="getCss('avatar')"
              :src="configurationData.avatarBackgroundImage"
            />
          </template>
        </li>
      </ul>
      <div
        :class="getCss('vertical-list-empty-text')"
        :style="emptyMemberVerticalListStyle"
        v-if="verticalMembers.length === 0"> {{configurationData.emptyText}}
      </div>

    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents, common } from '@tencent/ceiba-base-components';
const defaultUserIcon = 'https://game.gtimg.cn/images/js/img/lottery/default_head.png';
//  horizontal vertical
const  DISPLAY_TYPE_HORIZONTAL = 'horizontal'; //  横向显示列表
// const  DISPLAY_TYPE_VERTICAL = 'vertical'; // 垂直列表显示列表
const QUERY_TYPE_COMMANDER_SELL_CARD_LIST = 'commanderSellCard'; // 指挥官邀请售卡带货的
const QUERY_TYPE_INVITER_LIST = 'newVersionInvite'; // 查询新版邀请（主态邀请了那些人）
const QUERY_TYPE_INVITEE_LIST = 'newVersionQueryInvitee'; // 查询客态邀请（客态被那些人邀请）
export default {
  name: 'CPublicInviteList',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-invite-list-',
      // 当前滚动的index
      currentIndex: 0,
      // 邀请码
      inviteCode: '',
      inviteInfo: [],

    };
  },
  computed: {
    memberVerticalListStyle() {
      return {
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    emptyMemberVerticalListStyle() {
      const { emptyTextFontStyle =  {
        color: '#f1f0ed',
        fontFamily: 'PingFangSC-Regular',
        fontSize: '0.28rem',
        fontWeight: 500,
      } } = this.styles;
      return {
        width: this.styles.base.width,
        height: this.styles.base.height,
        lineHeight: this.styles.base.height,
        ...emptyTextFontStyle,
      };
    },
    // 横向显示
    isHorizontalDisplay() {
      const { displayType = DISPLAY_TYPE_HORIZONTAL } = this.configurationData;
      return displayType === DISPLAY_TYPE_HORIZONTAL;
    },
    arrowStyle() {
      return {
        marginTop: this.configurationData.showName ? '0.20rem' : '0',
      };
    },
    nickNameStyle() {
      const { fontFamily = 'Microsoft YaHei', textColor = '#e0dddb', textFontSize = '0.24rem', fontWeight = '400' } = this.styles?.listNameStyle ?? {};
      return {
        fontFamily,
        color: textColor,
        fontSize: textFontSize,
        fontWeight,
        textAlign: 'center',
      };
    },
    showArrowIcon() {
      return this.configurationData.tabStatus;
    },
    avatarBackgroundImageStyle() {
      return {
        backgroundImage: `url(${
          this.configurationData.avatarBackgroundImage || 'https://act.xinyue.qq.com/activity/tgclub/10419/b353b583f30c929fb807226270aaf381.png'
        })`,
      };
    },
    verticalMembers() {
      if (this.$isInEditor) {
        return  new Array(12).fill({ valid: false });
      }
      const list = [];
      const { length } = this.inviteInfo;
      for (let i = 0; i <= length - 1; i++) {
        list.push({ ...this.inviteInfo[i], valid: true });
      }
      console.log('---verticalMembers ---= ', list);
      return list;
    },
    members() {
      const list = [];
      let temp = [];
      // //  一排多少个 groupTotalSize = 0
      const { rowSize = 0, displayLimitNum = 0 } = this.configurationData;
      console.log('rowSize = ', rowSize);
      // 有多少人
      const { length } = this.inviteInfo;
      for (let i = 0; i <= length - 1; i++) {
        temp.push({ ...this.inviteInfo[i], valid: true });
        if (temp.length === rowSize) {
          list.push(temp);
          temp = [];
        }
      }
      // 剩余的 未满足5个
      if (temp.length > 0) {
        list.push([...temp, ...new Array(rowSize - temp.length).fill({ valid: false })]);
      }
      //  最后一排刚好满5个 在添加1排
      if (length < displayLimitNum && length % rowSize === 0) {
        list.push([...new Array(rowSize).fill({ valid: false })]);
      }
      console.log('list=', list);
      return list;
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    if (this.$isInEditor) return;
    await this.initialize();
    this.initListenScrollerEvent();
  },
  methods: {
    // 处理指挥官邀请带货列表
    async handleCommandListData() {
      const response = await this.flowRequest({
        flowId: this.configurationData.OpenidFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('query public invite list  response =', response);
      const { ret, data = {} } = response || {};
      if (ret !== 0) {
        return false;
      }
      let { data: list = [] } = data;
      const { ret: resRet = -1 } = data;
      if (resRet !== 0) {
        return false;
      }
      if (!list || list.length === 0) {
        return false;
      }
      list = [...list].reverse();
      const { displayLimitNum = 0 } = this.configurationData;
      console.log('displayLimitNum list = ', displayLimitNum, list instanceof Array, list.length);

      if (displayLimitNum > 0 && list instanceof Array && list.length > 0) {
        list = list.slice(0, displayLimitNum);
        console.log('displayLimitNum list = ', list);
      }
      const openidArray = list.filter(item => !/(^[1-9]\d*$)/.test(item.Openid));
      console.log('openidArray = ', openidArray);
      let wxOpenidArrayInfo = {};
      if (openidArray && openidArray.length > 0) {
        const wxOpenidArray = openidArray.map(item => item.Openid);
        const res = await this.$axiosInstance.get(`https://wang.xinyue.qq.com/api/headurl/list?openids=${wxOpenidArray.join(',')}`);
        console.log('/headurl/list?openids res = ', res);
        const { code = -1 } = res || {};
        if (code === 200) {
          wxOpenidArrayInfo = res?.data ?? {};
        }
      }
      const inviteData = [];
      list.forEach((item) => {
        const temp = {
          avatar: '',
          name: '',
        };
        if (/(^[1-9]\d*$)/.test(item.Openid)) {
          temp.avatar = `https://q3.qlogo.cn/headimg_dl?bs=qq&dst_uin=${item.Openid}&spec=100&url_enc=0&referer=bu_interface&term_type=PC`;
        } else {
          const tempUserInfo = wxOpenidArrayInfo[item.Openid] && typeof wxOpenidArrayInfo[item.Openid] === 'string'
            ? JSON.parse(wxOpenidArrayInfo[item.Openid]) : {};
          temp.avatar = tempUserInfo?.headurl ?? '';
        }
        inviteData.push(temp);
      });
      console.log('inviteData =', inviteData);
      this.inviteInfo = inviteData;
    },

    async handleInviteListDataNewVersion() {
      // this.inviteInfo =  (new Array(20).fill(1))
      //   .map(item => ({
      //     avatar: 'http://thirdqq.qlogo.cn/g?b=oidb&k=OPqiaUNe1DK7DdgzumFgFyw&s=100&t=1566724110',
      //     name: '121121111111111',
      //   })) ?? [];
      // return;
      // 邀请列表查询周期
      let { queryCycle = 'custom' } =  this.configurationData;
      const  {  activityId, customKey, dataType = QUERY_TYPE_INVITER_LIST } =  this.configurationData;
      queryCycle = queryCycle ?  queryCycle : 'custom';
      const params = {
        cycle: queryCycle,
        businessId: `${this.$actInfo?.ast}`,
        activityId: `${activityId ||  this.$actInfo?.activity_id}`,
        custom_key: customKey || '', //  自定义 key 默认活动号发
        isShowBeList: dataType ===  QUERY_TYPE_INVITEE_LIST ? 'yes' : 'no', // yes 主态查询客态  no  客态查询主态
      };
      console.log('getUserInviteListNewVersion params =', params);
      const response = await baseComponents.Apis.User.getUserInviteListNewVersion(params);

      const { ret, msg, data = {} } = response || {};
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { list = '{}', beList = '{}' } = data;

      let listRecord = [];
      if (dataType !== QUERY_TYPE_INVITEE_LIST) {
        listRecord = list &&  typeof  list === 'string' && list !== 'null' ?  JSON.parse(list) : [];
      } else {
        listRecord = beList &&  typeof  beList === 'string' && beList !== 'null' ?  JSON.parse(beList) : [];
      }
      if (!listRecord || listRecord.length === 0) {
        this.inviteInfo = [];
        return;
      }
      // listRecord = new Array(6).fill(listRecord[0]); //  mock 数据
      this.inviteInfo =  listRecord?.map(item => ({
        avatar: item.Avatar || defaultUserIcon,
        name: item.Name,
      })) ?? [];
    },
    accessHandle() {
      const { dataType = QUERY_TYPE_INVITER_LIST } = this.configurationData;

      // 指挥官邀请售卡带货
      if (dataType === QUERY_TYPE_COMMANDER_SELL_CARD_LIST) {
        this.handleCommandListData();
        return true;
      }
      // newVersionInvite 邀请助力记录 主态查询成功那些人被邀请
      if (dataType === QUERY_TYPE_INVITER_LIST) {
        this.handleInviteListDataNewVersion();
        return true;
      }
    },
    // 初始化
    async initialize() {
      const { dataType = QUERY_TYPE_INVITER_LIST } = this.configurationData;
      // this.handleInviteListDataNewVersion();
      // return;
      // 从弹框拉起的组件
      if (this.isLogin) {
        this.accessHandle();
        if (dataType === QUERY_TYPE_INVITEE_LIST) {
          this.handleInviteListDataNewVersion();
        }
        return;
      }
      // newVersionQueryInvitee  客态查询那些人邀请自己
      if (dataType === QUERY_TYPE_INVITEE_LIST) {
        this.$onQuaRefreshed(() => {
          this.handleInviteListDataNewVersion();
        });
        return;
      }
      this.$onLogined(() => {
        this.accessHandle();
      });
    },
    touchMovePre() {
      const { currentIndex } = this;
      if (currentIndex - 1 >= 0) {
        this.touchMoveEvent(currentIndex - 1);
      }
    },
    touchMoveNext() {
      const { currentIndex } = this;
      if (currentIndex + 1 <= this.members.length - 1) {
        this.touchMoveEvent(currentIndex + 1);
      }
    },
    touchMoveEvent(index) {
      this.currentIndex = index;
      const { offsetWidth } = this.$refs.groupWatchMemberScroller;
      this.$refs.groupWatchMemberScroller.style.webkitTransform = `translate3d(${-1 * index * offsetWidth}px, 0, 0)`;
    },
    // 增加监听
    initListenScrollerEvent() {
      if (!this.$refs.displayMemberContainer) return ;
      this.scrollContainerMain = this.$refs.displayMemberContainer;
      this.delta = {};
      //  开始滑动
      this.scrollContainerMain.addEventListener('touchstart', this.touchStartEvent);
      //  滑动结束
      this.scrollContainerMain.addEventListener('touchend', this.touchEndEvent);
    },
    touchStartEvent(event) {
      event.stopPropagation();
      this.delta = this.delta || {};
      this.delta.x = event.touches[0].pageX;
      this.delta.y = event.touches[0].pageY;
    },
    touchEndEvent(event) {
      event.stopPropagation();
      let { x, y } = this.delta;
      x -= event.changedTouches[0].pageX;
      y -= event.changedTouches[0].pageY;
      // 向左或向右滑动 距离不够
      if (Math.abs(x) < 5 && Math.abs(y) < 5) {
        return false;
      }
      const { currentIndex } = this;
      // 一定有向左滑动或向右滑动
      if (Math.abs(x) >= Math.abs(y)) {
        if (x > 0) {
          // ,右滑
          if (currentIndex + 1 <= this.members.length - 1) {
            this.touchMoveEvent(currentIndex + 1);
          }
        } else {
          // ,左滑
          if (currentIndex - 1 >= 0) {
            this.touchMoveEvent(currentIndex - 1);
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import 'styles';
</style>
